import TreebankService from './TreebankService';

export default TreebankService;
